<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'List Settings'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding">
            <tidy-input
              [label]="'List Name'"
              formControlName="title"
              [form]="form.controls.title"
              [icon]="'assets/svg/list.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter the name of the list'" />
          </tidy-row>
          <tidy-row class="field-top-padding">
            <tidy-textarea
              label="Description"
              [icon]="'assets/svg/create.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a description of the list'"
              [form]="form.controls.description"
              formControlName="description" />
          </tidy-row>
        </form>
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/checklist.svg'"
              class='header-size' />
            <tidy-text
              body="Require Custom Fields" />
            <div></div>
          </tidy-row>
          <tidy-toggle
            [toggled]="blockCompleteOnMissingFields"
            (toggleChanged)="blockCompleteOnMissingFields = !blockCompleteOnMissingFields" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            body="Require the pro to enter inputs into all your custom fields to complete the job. If disabled the pro will not be required to enter any inputs but will see an alert if they are skipping any fields you indicated are required." />
        </tidy-row>
      </tidy-card>
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundRenameList"
        class="primary" />
      <tidy-row [align]="'center'">
        <tidy-text
          [actionBody]="'Delete List'"
          (action)="deleteList()"
          class="red link" />
      </tidy-row>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
